import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Building2, MapPin, Heart, Target, ShieldCheck, Sparkles } from "lucide-react";
import BrandMark from "@/components/BrandMark";
import DisclaimerBanner from "@/components/DisclaimerBanner";

export default function QuienesSomos() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-zinc-50 pb-28">
      <header className="max-w-3xl mx-auto w-full px-5 pt-6 flex items-center justify-between">
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-sm font-semibold text-zinc-600 hover:text-zinc-900"
          data-testid="quienes-back"
        >
          <ArrowLeft className="w-4 h-4" />
          Inicio
        </button>
        <BrandMark size="sm" />
      </header>

      <div className="max-w-3xl mx-auto w-full px-5 pt-8">
        <p className="text-xs uppercase tracking-widest font-black text-red-600 mb-2">
          Quiénes somos
        </p>
        <h1 className="text-4xl sm:text-5xl font-black tracking-tighter text-zinc-900 leading-tight mb-4">
          La tecnología al servicio de quienes más la necesitan.
        </h1>
        <p className="text-base text-zinc-700 leading-relaxed mb-10">
          Construimos <span className="font-bold">miapoyo · Defiende Tus Derechos</span> con un propósito claro: que ninguna persona inmigrante en Estados Unidos enfrente sola un momento crítico por no saber qué decir, qué firmar, o a quién llamar.
        </p>

        {/* Identidad legal */}
        <div className="bg-white border-2 border-zinc-200 rounded-2xl p-6 mb-8" data-testid="empresa-card">
          <div className="flex items-start gap-3 mb-4">
            <div className="w-12 h-12 rounded-xl bg-zinc-900 flex items-center justify-center flex-shrink-0">
              <Building2 className="w-6 h-6 text-white" strokeWidth={2.5} />
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-widest font-black text-zinc-500">Razón social</p>
              <h2 className="text-xl font-black text-zinc-900 leading-tight">
                MARKETING DE INTELIGENCIA ARTIFICIAL S. de R.L. de C.V.
              </h2>
            </div>
          </div>
          <div className="flex items-start gap-3 pl-15 ml-15 border-t pt-4 border-zinc-100">
            <MapPin className="w-5 h-5 text-zinc-400 mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-[10px] uppercase tracking-widest font-black text-zinc-500 mb-0.5">Domicilio fiscal</p>
              <p className="text-base font-semibold text-zinc-900 leading-snug">
                Av. Américas 1545, pisos 20, 21 y 22
                <br />
                Guadalajara, Jalisco, México
              </p>
            </div>
          </div>
        </div>

        {/* Misión */}
        <div className="grid sm:grid-cols-2 gap-4 mb-10">
          <div className="bg-white border border-zinc-200 rounded-xl p-5">
            <Target className="w-7 h-7 text-red-600 mb-3" strokeWidth={2.5} />
            <h3 className="font-black text-zinc-900 mb-1">Nuestra misión</h3>
            <p className="text-sm text-zinc-700 leading-snug">
              Democratizar el acceso a información legal educativa con inteligencia artificial, en el idioma y momento que la comunidad inmigrante lo necesita.
            </p>
          </div>
          <div className="bg-white border border-zinc-200 rounded-xl p-5">
            <Heart className="w-7 h-7 text-rose-600 mb-3" strokeWidth={2.5} />
            <h3 className="font-black text-zinc-900 mb-1">Nuestros valores</h3>
            <p className="text-sm text-zinc-700 leading-snug">
              Empatía, privacidad absoluta, información veraz basada en fuentes oficiales, y respeto irrestricto a la dignidad humana.
            </p>
          </div>
        </div>

        <div className="bg-zinc-900 text-white rounded-2xl p-7 mb-8">
          <ShieldCheck className="w-8 h-8 text-emerald-400 mb-3" strokeWidth={2.5} />
          <h3 className="font-black text-xl mb-2 tracking-tight">Lo que SÍ somos</h3>
          <ul className="space-y-2 text-sm text-zinc-200 leading-relaxed">
            <li className="flex gap-2"><Sparkles className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0" /><span>Una plataforma SaaS de educación legal por voz, basada en fuentes oficiales públicas.</span></li>
            <li className="flex gap-2"><Sparkles className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0" /><span>Lectores asistidos de los manuales oficiales bajo PBNDS 2011 §&nbsp;6.3.</span></li>
            <li className="flex gap-2"><Sparkles className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0" /><span>Traductores e intérpretes automatizados entre inglés legal y español sencillo.</span></li>
            <li className="flex gap-2"><Sparkles className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0" /><span>Un directorio confiable de consulados latinos y organizaciones pro bono.</span></li>
          </ul>
        </div>

        <div className="bg-amber-50 border-2 border-amber-200 rounded-2xl p-6">
          <h3 className="font-black text-zinc-900 mb-2">Lo que NO somos</h3>
          <p className="text-sm text-zinc-800 leading-relaxed">
            No somos un bufete de abogados ni una firma de inmigración. No prestamos servicios legales ni representamos a clientes ante autoridades migratorias. La información que entregamos es <span className="font-bold">educativa e informativa</span>, no sustituye la asesoría de un abogado certificado.
          </p>
        </div>
      </div>
      <DisclaimerBanner />
    </div>
  );
}
